import React, { useContext, useEffect, useRef, useState } from 'react';
import AssistitoEditPanel, { AssistitoEditPanelHandle } from '../../components/assistitoEdit/AssistitoEditPanel';
import { UsersApi } from '../../data';
import { apiConfiguration } from '../../apiConfig';
import TenantContext from '../../contexts/tenantContext';
import { LoadPanel } from 'devextreme-react';



export default function AnagraficaPersonalePage() {
  const { currentTenant } = useContext(TenantContext);
  const assistitoEditPanelRef = useRef<AssistitoEditPanelHandle>(null);
  const [assistitoId, setAssistitoId] = useState<string>();
  const [loading, setLoading] = React.useState<boolean>(true);

  useEffect(() => {
    setLoading(true);

    const fetchData = async () => {
       var api = new UsersApi(apiConfiguration);
       setAssistitoId(undefined);

       setAssistitoId(await api.getMeAssistitoId({ tenantId: currentTenant.Id }));

       setLoading(false);
    };

    fetchData()
      // make sure to catch any error
      .catch(console.error);
  }, [currentTenant]);

  return (
    <React.Fragment>
          <h2 className={'content-block'}>Anagrafica personale</h2>
          <div className={'content-block'}>
            <div className={'dx-card responsive-paddings'} style={{ minHeight: '400px' }}>  
              { assistitoId &&
                <AssistitoEditPanel ref={assistitoEditPanelRef} assistitoId={assistitoId} bloccaAnagrafica={true} />
                }
            </div>
          </div>

           <LoadPanel
            shadingColor="rgba(0,0,0,0.4)"
            position={{ of: '.dx-card' }}
            visible={loading}
            showIndicator={true}
            shading={false}
            showPane={true}
            hideOnOutsideClick={false}
          />
        </React.Fragment>
  )
}
